var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.showNavbar)?_c('navbar'):_vm._e(),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[(_vm.showNavbar)?_c('navbar-side'):_vm._e(),_c('router-view',{staticClass:"col flex-grow-1",on:{"setNavbarVisibility":_vm.setNavbarVisibility}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }